import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Loader from 'components/Loader';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { BlackBtn } from 'images/index';

import { showDrawer as showDrawerRequest } from 'containers/DrawerManager/actions';
import { selectBillingAccounts } from 'containers/PrimoProfile/selectors';
import { Button, SuccessBlock, H2 } from 'components/Ui';
import { selectIsEditEmailSuccessful } from '../selectors';
import EmailBlock from './EmailBlock';

import styles from './styles.scss';
import commonStyles from '../styles.scss';

import { ADD_NEW_ACCOUNT_LOGIN } from './constants';

const EditEmailAddressForm = ({
  onClose,
  showDrawer,
  billingAccounts,
  isEditEmailSuccessful,
}) => {
  const isBankAccountFetching = false;

  const showAddNewAccountLogin = true;

  return (
    <Fragment>
      {!isEditEmailSuccessful ? (
        <ValidatorForm onSubmit={() => {}}>
          <H2 className={commonStyles.header}>Manage email/username</H2>
          <div className={styles.inputContainer}>
            <div className={styles.inputFields}>
              <Loader loading={isBankAccountFetching} local>
                {billingAccounts.map((billingAccount) => (
                  <EmailBlock
                    key={billingAccount.userName}
                    billingAccount={billingAccount}
                    onClose={() => {}}
                  />
                ))}
                <div className={styles.blockSeparator}></div>
              </Loader>
              {showAddNewAccountLogin && (
                <div className={styles.addAccountLogin}>
                  <Button
                    icon={
                      <img src={BlackBtn} alt="add" className={styles.icon} />
                    }
                    onClick={() => {
                      showDrawer(ADD_NEW_ACCOUNT_LOGIN);
                      onClose();
                    }}
                    link
                    type="button"
                    tracking="Add Account Login"
                    ariaLabel="Add a new account login"
                  />
                  <span className={styles.text}>Add a new account login</span>
                </div>
              )}
            </div>
          </div>
          <Fragment>
            <div className={styles.formBottom}>
              <Button
                className={styles.button}
                text="Done"
                type="button"
                onClick={onClose}
              />
            </div>
          </Fragment>
        </ValidatorForm>
      ) : (
        <div className={styles.successContainer}>
          <SuccessBlock text="Your changes have been saved." />
        </div>
      )}
    </Fragment>
  );
};

EditEmailAddressForm.propTypes = {
  showDrawer: PropTypes.func.isRequired,
  isEditEmailSuccessful: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  billingAccounts: selectBillingAccounts(),
  isEditEmailSuccessful: selectIsEditEmailSuccessful(),
});

const mapDispatchToProps = {
  showDrawer: showDrawerRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditEmailAddressForm);
